import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwUnitsApiService } from 'app/services/units-api.service';
import * as unitsActions from '../actions/units.actions';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class UnitsEffects {
  loadUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitsActions.loadUnits),
      switchMap(() =>
        this.unitsApiService.load().pipe(
          map((response) => unitsActions.loadUnitsSuccess({ response })),
          catchError((error) => of(unitsActions.loadUnitsFailed({ error })))
        )
      )
    )
  );

  createUnit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitsActions.createUnit),
      switchMap(({ unit }) =>
        this.unitsApiService.create(unit).pipe(
          switchMap(() => [
            unitsActions.createUnitSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_unit_successful',
              },
            }),
          ]),
          catchError((error) => of(unitsActions.createUnitFailed({ error })))
        )
      )
    )
  );

  updateUnit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitsActions.updateUnit),
      switchMap(({ unit }) =>
        this.unitsApiService.update(unit).pipe(
          switchMap((response) => [
            unitsActions.updateUnitSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_unit_successful',
              },
            }),
          ]),
          catchError((error) => of(unitsActions.updateUnitFailed({ error })))
        )
      )
    )
  );

  deleteUnit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitsActions.deleteUnits),
      switchMap(({ unit }) =>
        this.unitsApiService.delete(unit).pipe(
          switchMap(() => [
            unitsActions.deleteUnitsSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_units_successful',
              },
            }),
          ]),
          catchError((error) => of(unitsActions.deleteUnitsFailed({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private unitsApiService: MwUnitsApiService
  ) {}
}
